import { render, staticRenderFns } from "./PasswordResetEmailSentModal.vue?vue&type=template&id=9cb38968&scoped=true&"
import script from "./PasswordResetEmailSentModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetEmailSentModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetEmailSentModal.vue?vue&type=style&index=0&id=9cb38968&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb38968",
  null
  
)

export default component.exports